module.exports = __webpack_public_path__ + "img/jet6_banner.ef2a2659.jpg";